/**
 * Bring a tab up to date the moment it returns to the foreground (2026-11-04).
 *
 * Hidden tabs make no background device fetches (see GlobalAccess.getDevices),
 * and a browser may drop or freeze their sockets, so the return restores the
 * notify sockets and refreshes once. This runs on every route; the Site page's
 * own visibility refetch coalesces with it through the fetch mutex.
 */

import GlobalAccess from './globalAccess';
import WebSocketService from './websocketService';
import { isTabHidden } from '../utils/tabVisibility';

/**
 * @param {object} app - The App instance
 * @returns {Function} uninstall
 */
export function installForegroundRestore(app) {
  let hiddenAtMs = isTabHidden() ? Date.now() : null;

  const restore = (hiddenForMs) => {
    WebSocketService.restoreConnections(hiddenForMs);
    GlobalAccess.getDevices(app);
  };

  const onVisibilityChange = () => {
    if (isTabHidden()) {
      if (hiddenAtMs === null) hiddenAtMs = Date.now();
      return;
    }
    const hiddenForMs = hiddenAtMs === null ? 0 : Date.now() - hiddenAtMs;
    hiddenAtMs = null;
    restore(hiddenForMs);
  };

  // A page restored from the back/forward cache lost its sockets while frozen.
  const onPageShow = (event) => {
    if (event.persisted) restore(Infinity);
  };

  document.addEventListener('visibilitychange', onVisibilityChange);
  window.addEventListener('pageshow', onPageShow);

  return () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.removeEventListener('pageshow', onPageShow);
  };
}
